export default {
  'Choose File': 'Bestand kiezen',
  'Please paste a URL': 'Alstublieft plak een URL',
  'Loading': 'Belading',
  'Analyzing': 'Analyseren',
  'Try a sample': 'Probeer een monster',
  'Sorry, error occurs when analyzing the URL.': 'Sorry, fout optreedt bij het analyseren van de URL.',
  'Upload a photo': 'Upload een foto',
  "Drag and drop files to the upload box.": 'Slepen en neerzetten bestanden naar de upload box.',
  'Please select the proper position with portrait.': 'Kies de juiste positie bij portret.',
  'downloading': 'Downloaden',
}